import React, { Component } from "react";
import AutoInput from "../containers/AutoInput";
import withValues from "../hocs/withValues";
import { getValue } from "../utils/models";
import { getBelongsToValue } from "../utils/models";

class LocalEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showContent: false,
      seal: getValue(this.props.values, "seal"),
      vol: getValue(this.props.values, "vol"),
      weight: getValue(this.props.values, "weight"),
      packagesContainers: getValue(this.props.values, "weight")
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.values.seal !== prevProps.values.seal) {
      this.setState({
        seal: getValue(this.props.values, "seal")
      });
    }
    if (this.props.values.weight !== prevProps.values.weight) {
      this.setState({
        weight: getValue(this.props.values, "weight")
      });
    }
    if (this.props.values.packagesContainers !== prevProps.values.packagesContainers) {
      this.setState({
        packagesContainers: getValue(this.props.values, "packagesContainers")
      });
    }
  }

  render() {
    return (
      <div>
        <AutoInput
          form={this.props.form}
          model={"arrivalnotification"}
          attribute={"arrivalnotification"}
          value={getBelongsToValue("arrivalnotification", this.props.belongsTo)}
          hidden={true}
        />
        <AutoInput
          form={this.props.form}
          model={"containers"}
          attribute={"seal"}
          autosave
          value={getValue(this.props.values, "seal")}
          onChange={value => {
            this.setState({ seal: value });
          }}
        />{" "}
        <AutoInput
          form={this.props.form}
          model={"containers"}
          attribute={"vol"}
          autosave
          value={getValue(this.props.values, "vol")}
          onChange={value => {
            this.setState({ vol: value });
          }}
        />{" "}
        <AutoInput
          form={this.props.form}
          model={"containers"}
          attribute={"weight"}
          autosave
          value={getValue(this.props.values, "weight")}
          onChange={value => {
            this.setState({ weight: value });
          }}
        />
        <AutoInput
          form={this.props.form}
          model={"containers"}
          attribute={"packagesContainers"}
          autosave
          value={getValue(this.props.values, "packagesContainers")}
          onChange={value => {
            this.setState({ packagesContainers: value });
          }}
        />
      </div>
    );
  }
}

export default withValues(LocalEdit);



// WEBPACK FOOTER //
// ./src/forms/ContainersEdit.js